const ITEMS = [
  {
    n: "01",
    title: "Four 1-on-1 trainings with Alex",
    body: "Direct. Recorded. Not a coach. The actual person who cleared $100k before turning 18. Spaced across the program so you get correction in real time.",
  },
  {
    n: "02",
    title: "The full framework library",
    body: "Every structure, every script, every objection map used to do over a million in personal sales. You don't have to invent the language. You have to drill it.",
  },
  {
    n: "03",
    title: "AI sales trainer",
    body: "Roleplays every call type, every objection, every stall. Drill until your tone is automatic. Burn the awkward in private, not on real leads.",
  },
  {
    n: "04",
    title: "The private network",
    body: "The standard stays alive daily. Win posts, deal breakdowns, frame audits. You're never on an island.",
  },
  {
    n: "05",
    title: "A direct line to real offers",
    body: "When your frame is locked and your reps are in, we put you in front of real paid offers. Not a job board. A direct line. You still pass the bar yourself — but you don't knock on the door alone.",
  },
];

export default function InsideProgram() {
  return (
    <section id="inside" className="access-section bg-room-2 border-y border-soft">
      <div className="access-container">
        <div className="max-w-3xl">
          <span className="mono-label mono-label-gold">WHAT YOU GET WHEN YOU JOIN</span>
          <h2 className="h-section mt-5">Here is everything in the room.</h2>
        </div>

        <ol className="mt-12 divide-y divide-soft border-y border-soft">
          {ITEMS.map((it) => (
            <li key={it.n} className="grid md:grid-cols-[80px_1fr_2fr] gap-6 md:gap-10 py-8 md:py-10">
              <div className="mono-label mono-label-gold">{it.n}</div>
              <h3 className="font-display text-bone text-xl md:text-2xl leading-tight">{it.title}</h3>
              <p className="text-dim body-lg max-w-xl">{it.body}</p>
            </li>
          ))}
        </ol>

        <p className="mt-8 text-mute text-sm">
          The investment is discussed on the call. Not because it's secret. Because we structure it to your situation.
        </p>
      </div>
    </section>
  );
}
